import Vue from "vue";
import $ from "jquery";
import axios from "axios";
import BootstrapVue from "bootstrap-vue";
// @ts-ignore
import vSelect from "vue-select";
import ToggleButton from "vue-js-toggle-button";
// import VueScrollTo from "vue-scrollto";
import {
	store,
	auth,
	settings,
	vip,
	toaster,
	currency,
} from "@/loader/public";

import "@/plugin/fontawesome";

import { router } from "./module/public/route";
import App from "./module/public/App.vue";
import ActionRow from "./module/public/component/ActionRow.vue";
import CertificateIcon from "./module/public/component/certificate/CertificateIcon.vue";
import CertificateStatusBadge from "./module/public/component/certificate/CertificateStatusBadge.vue";
import ContactSelect from "./module/public/component/contact/ContactSelect";
import IpSelect from "./module/public/component/ip/IpSelect.vue";
import IpBadge from "./module/public/component/ip/IpBadge.vue";
import IpLeaf from "./module/public/component/ip/IpLeaf.vue";
import ProjectStatusBadge from "./module/public/component/project/ProjectStatusBadge.vue";
import TextEdit from "./component/TextEdit.vue";
import YesNoCheckbox from "./component/YesNoCheckbox.vue";
import CompanySelect from "./module/public/component/company/CompanySelect.vue";
import UserSelect from "./module/public/component/user/UserSelect";

import "./module/public/scss/style.scss";

$(function() {
	Vue.use(BootstrapVue, {
		BCalendar: {
			labelCalendar: "Calendrier",
			labelCurrentMonth: "Mois en cours",
			labelHelp: "Utiliser les flèches pour naviguer dans le calendrier",
			labelNav: "Naviguation",
			labelNextDecade: "Décennie suivante",
			labelNextMonth: "Mois suivant",
			labelNextYear: "Année suivante",
			labelNoDateSelected: "Aucune date sélectionnée",
			labelPrevDecade: "Décennie préscédente",
			labelPrevMonth: "Mois précédent",
			labelPrevYear: "Année précédente",
			labelSelected: "Date sélectionnée",
			labelToday: "Aujourd'hui",
			startWeekday: 1,
		},
		BFormDatepicker: {
			labelCloseButton: "Fermer",
			labelResetButton: "Effacer",
			labelTodayButton: "Sélectionner Aujourd'hui",
		},
		BFormFile: {
			browseText: "Parcourir",
			dropPlaceholder: "Déposer le fichier ici ...",
			dropLabel: "Vous pouvez glisser un fichier ci-dessous",
			placeholder: "Choisissez ou déposez un fichier ici ...",
		},
		BPagination: {
			labelPage: "Page",
			labelFirstPage: "Première page",
			labelLastPage: "Dernière page",
			labelNextPage: "Page suivante",
			labelPrevPage: "Page précédente",
		},
	});
	Vue.use(ToggleButton);
	Vue.component("v-select", vSelect);
	Vue.component("action-row", ActionRow);
	Vue.component("text-edit", TextEdit);
	Vue.component("yes-no-checkbox", YesNoCheckbox);
	Vue.component("certificate-icon", CertificateIcon);
	Vue.component("certificate-status-badge", CertificateStatusBadge);
	Vue.component("ip-badge", IpBadge);
	Vue.component("ip-select", IpSelect);
	Vue.component("ip-leaf", IpLeaf);
	Vue.component("contact-select", ContactSelect);
	Vue.component("user-select", UserSelect);
	Vue.component("project-status-badge", ProjectStatusBadge);
	Vue.component("company-select", CompanySelect);
	// Vue.use(VueScrollTo);
	// Vue.directive
	Vue.filter("currency", currency.format);
	Vue.filter("plural", (qty: number, text: string) => {
		return qty > 1 ? text.plural() : text;
	});
	// Vue.filter("currencyNoDecimal", currencyNoDecimal.format);
	// Vue.filter("percent", percent.format);

	if (document.getElementById("vip")) {
		new Vue({
			el: "#vip",
			store,
			router,
			render: (h) => h(App),
			beforeCreate() {
				settings.init();
				toaster.setToaster(this.$bvToast);
				toaster.setDefaultOptions({
					solid: true,
					title: "Certival",
					toaster: "b-toaster-top-center"
				});
				auth.init();
				vip.init();
				vip.setModal(this.$bvModal);
			},
		});
	}

	if (process.env.NODE_ENV !== "production") {
		// @ts-ignore
		window.axios = axios;
	}
});
